import { IRegistrationData } from '@shared/model/basic-data';
import { createReducer, on } from '@ngrx/store';
import { getRegistrationDataSuccess, updateRegistrationDataSuccess } from '../actions';

const initialState: IRegistrationData = {
  company_sme: undefined,
  date_init: undefined,
  name: undefined,
};

export const registrationDataReducer = createReducer(
  initialState,
  on(getRegistrationDataSuccess, (state, { registrationData }) => registrationData),
  on(updateRegistrationDataSuccess, (state, { data }) => ({ ...state, [data.name]: data.value })),
);
